import { render, staticRenderFns } from "./SectionSubs.vue?vue&type=template&id=47e48407&scoped=true"
import script from "./SectionSubs.vue?vue&type=script&lang=js"
export * from "./SectionSubs.vue?vue&type=script&lang=js"
import style0 from "./SectionSubs.vue?vue&type=style&index=0&id=47e48407&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e48407",
  null
  
)

export default component.exports